import { render, staticRenderFns } from "./ClientDefaultPayment.vue?vue&type=template&id=abf8bb38"
import script from "./ClientDefaultPayment.vue?vue&type=script&lang=js"
export * from "./ClientDefaultPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports